const QUEUE_KEY = "qre_pending_scans";

function readQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]");
  } catch {
    return [];
  }
}

function writeQueue(queue) {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
}

function makeClientId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function queueLength() {
  return readQueue().length;
}

// Persists a scan locally so it isn't lost if the network request never went out
// (e.g. the fetch itself failed). Returns the clientId used for the eventual sync.
export function enqueueScan(barcode, extras = {}) {
  const item = { clientId: makeClientId(), barcode, queuedAt: Date.now(), ...extras };
  const queue = readQueue();
  queue.push(item);
  writeQueue(queue);
  return item.clientId;
}

// Attempts to POST every queued scan to the backend. The backend dedups by
// client_id, so retrying an item that already made it through is a no-op.
// Stops at the first failure (network down or server rejected) to preserve order.
export async function flushQueue(apiBase, token) {
  let queue = readQueue();
  let synced = 0;

  for (const item of [...queue]) {
    try {
      const response = await fetch(`${apiBase}/barcode`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
        body: JSON.stringify({
          barcode: item.barcode,
          client_id: item.clientId,
          quantity: item.quantity || 1,
          category: item.category || null,
          location: item.location || null,
          note: item.note || null,
        }),
      });
      if (!response.ok) break;
      queue = queue.filter((q) => q.clientId !== item.clientId);
      writeQueue(queue);
      synced++;
    } catch (e) {
      break;
    }
  }

  return { synced, remaining: queue.length };
}
